import {createContext, useContext} from 'react';
export const LANGUAGES = [
  {id:'en', label:'English', html:'en-US'},
  {id:'fr', label:'Français', html:'fr'},
  {id:'de', label:'Deutsch', html:'de'},
  {id:'es', label:'Español', html:'es'},
  {id:'zh', label:'中文', html:'zh-CN'},
];
export const LanguageContext=createContext({language:'en',setLanguage:()=>{}});
export const useLanguage=()=>useContext(LanguageContext);
